<section class="contact-us" id="contact-us">
  <h2>Contact <span class="accent">us</span></h2>

  <div class="contact-us-layout">
    <div class="contact-options">
      <button type="button" class="contact-option" *ngFor="let option of contactOptions" (click)="option.action()">
        <i [class]="option.icon"></i>
        <span class="contact-option-title">{{ option.title }}</span>
        <span class="contact-option-desc">{{ option.description }}</span>
      </button>
    </div>

    <div class="contact-info-panel">
      <h3>Reach us directly</h3>
      <ul>
        <li>
          <i class="fas fa-phone"></i>
          <a [href]="'tel:' + contactData.phone">{{ contactData.phone }}</a>
        </li>
        <li>
          <i class="fas fa-envelope"></i>
          <a [href]="'mailto:' + contactData.email">{{ contactData.email }}</a>
        </li>
        <li>
          <i class="fas fa-map-marker-alt"></i>
          <a [href]="contactData.googleMapsUrl" target="_blank" rel="noopener noreferrer">{{ contactData.address }}</a>
        </li>
      </ul>
      <p class="response-time">We usually reply within one business day.</p>
    </div>
  </div>
</section>
